import React from "react";

export const LoaderSmall = () => {
  return (
    <div className="loader-div">
      <img src="./images/preloader.svg" />
    </div>
  );
};
